import React, { useCallback, useEffect, useState } from "react";
import Colors from "../../../../../../constants/Colors";
import useResponsiveInfo from "../../../../../../hooks/useResponsiveInfo";
import {
  ModalAttendanceButtonsContainer,
  ModalAttendanceCardContainer,
  ModalAttendanceTextCardContainer,
  AttendanceCardModal,
  AttendanceCardModalContainer,
  AttendanceModalOverFlow,
} from "../modalAttendanceRecord/ModalAttendanceRecord.styled";
import {
  H1,
  Text,
  TitleLarge,
} from "../../../../../../components/UI/generalLayout/Layout.styled";
import { Spacer } from "../../../../../../components/UI/spacer/spacer";
import { Button } from "../../../../../company/companyRegister/CompanyRegister.styled";
import CheckBox from "../../../../../../components/checkbox/Checkbox";
import * as appointmentActions from "../../../../../../store/actions/appointment";
import { useAppDispatch } from "../../../../../..";
import { Alert } from "@mui/material";
export interface ModalImpreviveisProps {
  modalOpen: boolean;
  idAtendimento: string;
  onCloseModal: () => void;
  dados: any;
}

const ModalImpreviveis: React.FC<ModalImpreviveisProps> = ({
  modalOpen,
  idAtendimento,
  onCloseModal,
  dados,
}) => {
  const { isMobile } = useResponsiveInfo();
  const dispatch = useAppDispatch();

  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [arrayImpression, setArrayImpression] = useState<any>([]);
  const [message, setMessage] = useState<any>([]);
  const [optionsImpremiveis, setOptionsImpremiveis] = useState<any[]>([]);

  const removeElementArrayList = (value: string) => {
    const i = arrayImpression.findIndex((x: any) => x === value);
    const listClone = [...arrayImpression];
    listClone.splice(i, 1);
    setArrayImpression([...listClone]);
  };

  const fetchPdfs = useCallback(async () => {
    await dispatch(appointmentActions.getPdfs(idAtendimento, arrayImpression));
    setMessage("Impressão gerada com sucesso.");
  }, [arrayImpression, idAtendimento]);

  const fetchImprimiveis = async () => {
    const arrays = await appointmentActions.fetchImprimiveis();

    let newArray = [];

    for (const list of arrays) {
      switch (list.codigo) {
        case "Receituario": {
          const data = {
            ...list,
            disabled: dados.receituarios,
          };
          newArray.push(data);
          break;
        }
        case "ReceituarioEspecial": {
          const data = {
            ...list,
            disabled: dados.receituariosEspeciais,
          };
          newArray.push(data);
          break;
        }
        case "Exames": {
          const data = {
            ...list,
            disabled: dados.exames,
          };
          newArray.push(data);
          break;
        }
        case "AtestadoDeclaracao": {
          const data = {
            ...list,
            disabled: dados.atestadoDeclaracao,
          };
          newArray.push(data);
          break;
        }
        case "Encaminhamento": {
          const data = {
            ...list,
            disabled: dados.encaminhamentos,
          };
          newArray.push(data);
          break;
        }
        case "LiberacaoProfissional": {
          const data = {
            ...list,
            disabled: dados.liberacaoProfissional,
          };
          newArray.push(data);
          break;
        }
        case "Evolucao": {
          const data = {
            ...list,
            disabled: dados.evolucao,
          };
          newArray.push(data);
          break;
        }
      }
    }

    setOptionsImpremiveis(newArray);
  };

  const atualizationImpression = (dadosValue: any, active: boolean) => {
    active
      ? removeElementArrayList(dadosValue)
      : setArrayImpression((prevList: any) => [...prevList, dadosValue]);
  };

  useEffect(() => {
    fetchImprimiveis();
  }, []);

  useEffect(() => {
    fetchImprimiveis();
  }, [
    dados?.receituarios,
    dados?.receituariosEspeciais,
    dados?.exames,
    dados?.atestadoDeclaracao,
    dados?.encaminhamentos,
    dados?.liberacaoProfissional,
    dados?.evolucao
  ]);

  useEffect(() => {
    arrayImpression.length > 0
      ? setButtonDisabled(false)
      : setButtonDisabled(true);
  }, [arrayImpression]);

  return (
    <AttendanceCardModal open={modalOpen}>
      <AttendanceCardModalContainer isMobile={isMobile}>
        <ModalAttendanceCardContainer>
          <ModalAttendanceTextCardContainer>
            <H1
              style={{
                fontSize: "36px",
              }}
              color={Colors.SPM600}
            >
              Impressão de registro
            </H1>
            {message.length !== 0 && (
              <Alert
                severity="success"
                variant="filled"
                onClose={() => {
                  setMessage([]);
                }}
              >
                {message}
              </Alert>
            )}
          </ModalAttendanceTextCardContainer>
          <Spacer bottom={20} />
          <AttendanceModalOverFlow isMobile={isMobile}>
            <TitleLarge style={{ fontSize: "20px" }}>
              Selecione documentos
            </TitleLarge>
            {optionsImpremiveis?.map((d, index) => (
              <CheckBox
                key={index}
                title={d.nome}
                variavel={d.codigo}
                isDisabled={d?.disabled}
                onClick={atualizationImpression}
              />
            ))}
          </AttendanceModalOverFlow>

          <Spacer bottom={10} />
          <ModalAttendanceButtonsContainer>
            <Button
              onClick={() => {
                onCloseModal();
                setMessage([]);
                setArrayImpression([]);
              }}
              color={Colors.lightBlue}
              backgroundColor={Colors.WHITE}
              borderColor={Colors.lightBlue}
            >
              Cancelar
            </Button>
            <Button
              onClick={() => fetchPdfs()}
              color={Colors.WHITE}
              backgroundColor={Colors.SPM600}
              disabled={buttonDisabled}
            >
              Imprimir
            </Button>
          </ModalAttendanceButtonsContainer>
        </ModalAttendanceCardContainer>
      </AttendanceCardModalContainer>
    </AttendanceCardModal>
  );
};

export default ModalImpreviveis;
